export default __webpack_public_path__ + "static/media/10SecMulti.a890076e.wav";